/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getAccounts} from '../api'

 export const useQueryGetAccounts = createReactQueryHook('getAccounts', getAccounts)
